<template>
  <card @click="handleClick">
    <span slot="top-left">{{ race.race_location }}</span>
    <span slot="top-right">{{ race.race_code }}</span>
    <template slot="middle">
      <span class="img-count">
        Img:
        <b class="fs-16">{{ race.total_images }}</b>
      </span>
      <span class="date">{{ raceDate }}</span>
    </template>
    <img :src="imgPath" :alt="race.race_location" class="img" />
  </card>
</template>

<script>
import { formatDate } from '@/utils/utils'
import Card from './Card'

export default {
  name: 'RaceCard',
  components: {
    Card,
  },
  props: {
    race: {
      type: Object,
      required: true
    }
  },
  computed: {
    imgPath() {
      return process.env.VUE_APP_BASE_API_PATH + this.race?.track_image
    },
    raceDate() {
      return formatDate(this.race.race_date)
    }
  },
  methods: {
    handleClick() {
      this.$router.push({ name: 'race', params: { raceId: this.race._id }})
    }
  }
}
</script>

<style lang="scss" scoped>
.img {
  width: 240px;
  height: 96px;
  margin: auto;
  margin-top: 8px;
}

.img-count,
.date {
  display: flex;
  gap: 6px;
  color: var(--v-grey-lighten-1);
  font-weight: 500;
}
</style>
